import { Box, BoxProps, keyframes } from '@chakra-ui/react';

const DURATION = 2; // seconds

const GROW = keyframes`
  0% {
    transform: scale(1);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  100%   {
    opacity: 0;
    transform: scale(2.75);
  }
`;

const colorStrip = {
  content: '""',
  display: 'block',
  position: 'absolute',
  inset: 0,
  backgroundImage:
    'radial-gradient(#D36F58 5%, #E9E76E, #D36F58, #4F4DB0, #74EEF9, #222E90, #89DCE4, #222E90)',
  backgroundSize: '100% 521%',
  backgroundPosition: 'center',
  animation: `${GROW} ${DURATION}s cubic-bezier(0.335, 0.030, 1.000, 1.000) infinite both`,
};

export const ProminentButtonEffect = ({ position, ...boxProps }: BoxProps) => (
  <Box
    position={position && position !== 'static' ? position : 'relative'}
    borderRadius="inherit"
    overflow="hidden"
    transform="translateY(0)"
    _before={{
      ...colorStrip,
      animationDelay: `${(DURATION / 2).toFixed(3)}s`,
    }}
    _after={colorStrip}
    {...boxProps}
  />
);
